/**
 * The locales we actually ship payment translations for. This is intentionally
 * decoupled from the GraphQL `Language` enum: that enum can gain new members
 * (as the schema adds languages) before their translations exist, which would
 * otherwise make `i18n[locale]` unsafe.
 */
export const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

/**
 * Narrow an arbitrary locale down to a language we have translations for,
 * falling back to English. Lets callers index i18n JSON directly
 * (`i18n[toSupportedLanguage(locale)]`) without coupling to `Language`.
 */
export function toSupportedLanguage(locale: unknown): SupportedLanguage {
  return typeof locale === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(locale)
    ? (locale as SupportedLanguage)
    : 'en'
}
